import type { IconName } from '@fortawesome/fontawesome-svg-core'
import type { BED_TYPES } from '~/constants/rv'
import type { BookingReviewCategoryType, InsurancePlan, Nullable } from '~/types'

const BED_TYPE_ICONS: Record<BED_TYPES, IconName> = {
  BedKing: 'bed-front',
  BedQueen: 'bed-front',
  BedDinette: 'bed-empty',
  BedSofa: 'couch',
  BedBunkTwin: 'bed-bunk',
  BedBunkDouble: 'bed-bunk',
}

const PROTECTION_PLAN_ICONS: Record<InsurancePlan, IconName> = {
  Basic: 'shield',
  Standard: 'shield-check',
  Premium: 'shield-plus',
  Stationary: 'shield-halved',
  StationaryPlus: 'shield-plus',
}

const BOOKING_REVIEW_CATEGORY_ICONS: Record<Exclude<BookingReviewCategoryType, 'Unknown'>, IconName> = {
  ListingAccuracy: 'shield-check',
  Value: 'tag',
  Cleanliness: 'broom-wide',
  Communication: 'message',
}

/**
 * Lookup the icon for a bed type.
 *
 * @param bedType The bed type to look up.
 * @returns The Font Awesome icon name for the bed type.
 */
export function lookupBedTypeIcon(bedType: BED_TYPES): IconName {
  return BED_TYPE_ICONS[bedType]
}

/**
 * Lookup the icon for a protection plan.
 *
 * @param plan The protection plan to look up.
 * @returns The Font Awesome icon name for the plan, or `truck-tow` when no plan is provided.
 */
export function lookupProtectionPlanIcon(plan?: Nullable<InsurancePlan>): IconName {
  if (!plan) {
    return 'truck-tow'
  }

  return PROTECTION_PLAN_ICONS[plan]
}

export function lookupBookingReviewCategoryIcon(category: Exclude<BookingReviewCategoryType, 'Unknown'>): IconName {
  return BOOKING_REVIEW_CATEGORY_ICONS[category]
}
